var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"home-view","fluid":"","tag":"section"}},[_c('v-row',[_c('div',{staticClass:"text-h3"},[_vm._v(" Hola "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.userInfo.lastname))]),_vm._v(", te damos la bienvenida a nuestro sistema de control de tiempos de capacitación de Salles Sainz Grant Thornton. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }